import client from '@/api/client.js';
import i18n from '@/plugins/i18n.js';
import store from "@/store";
export default {
    methods: {
        async searchModelByString({ querystring, includeInactive }) {
            var meta = {
                clientApiMethod: 'searchModelByString',
                input: { querystring: querystring, includeInactive: includeInactive }
            }
            var query = "?searchQuery=" + querystring + "&IncludeInactive=" + includeInactive;
            var response = await client().get(store.state.apiRouteRoot + "MachineModel/search" + query, { meta: meta })
            return response.data;
        },

        async getMachineModelList() {
            var response = await client().get(store.state.apiRouteRoot + 'MachineModel', { meta: { clientApiMethod: 'getMachineModelList' } })
            return response?.data;
        },

        async getMachineModelListFromFilter(filter, cancelationToken) {
            var meta = { clientApiMethod: 'getMachineModelListFromFilter', input: { filter: filter } }
            var response = await client().get(store.state.apiRouteRoot + "MachineModel/Filtered", { params: filter, signal: cancelationToken, meta: meta })
            return response?.data;
        },

        async getModelById(modelId) {
            var meta = { clientApiMethod: 'getModelById', input: { modelId: modelId } }
            var response = await client().get(store.state.apiRouteRoot + "MachineModel/" + modelId, { meta: meta })
            return response?.data;
        },

        async getSupplierFailureCodeUsageByModelId(modelId) {
            var meta = { clientApiMethod: 'getSupplierFailureCodeUsageByModelId', input: { modelId: modelId } }
            var response = await client().get(`${store.state.apiRouteRoot}MachineModel/${modelId}/SupplierFailureCodeUsage`, { meta: meta })
            return response?.data;
        },

        async getJobUsageByModelId(modelId) {
            var meta = { clientApiMethod: 'getSupplierFailureCodeUsageByModelId', input: { modelId: modelId } }
            var response = await client().get(`${store.state.apiRouteRoot}MachineModel/${modelId}/Jobs`, { meta: meta })
            return response?.data;
        },

        async getJobTypeUsageByModelId(modelId) {
            var meta = { clientApiMethod: 'getSupplierFailureCodeUsageByModelId', input: { modelId: modelId } }
            var response = await client().get(`${store.state.apiRouteRoot}MachineModel/${modelId}/JobTypes`, { meta: meta })
            return response?.data;
        },

        async createModel(newmodel, image) {
            //console.log('model', newmodel, image);
            let formData = new FormData();
            if (image) {
                formData.append("ImageFile", image, image.name);
            }
            formData.append("MachineModel", JSON.stringify(newmodel));
            var meta = {
                clientApiMethod: 'createModel',
                input: { newmodel },
                successText: i18n.t("servicesystem.responses.created_object", { okey: i18n.t("servicesystem.common_objects.machine.model") }),
            }
            var response = await client().post(store.state.apiRouteRoot + "MachineModel", formData, {
                headers: { "Content-Type": "multipart/form-data" },
                transformRequest: formData => formData,
                meta: meta
            })
            return response?.data;
        },

        async changeModel(model, image) {
            //console.log('model', model, image);
            let formData = new FormData();
            if (image) {
                formData.append("ImageFile", image, image.name);
            }
            formData.append("MachineModel", JSON.stringify(model));
            var meta = {
                clientApiMethod: 'changeModel',
                input: { model },
                successText: i18n.t("servicesystem.responses.changed_object", { okey: i18n.t("servicesystem.common_objects.machine.model") })
            }
            var response = await client().patch(store.state.apiRouteRoot + "MachineModel", formData, {
                headers: { "Content-Type": "multipart/form-data" },
                transformRequest: formData => formData,
                meta: meta
            })
            return response?.data;
        },
    }
}